/**
 * @typedef {Object} LabArticleData
 * @property {string} id
 * @property {string} title
 * @property {string} section
 * @property {string} url
 * @property {string[]} verticals
 */

/**
 * Returns the data for a Labrador article given its container element.
 *
 * @param {Element} containerEl - Container element
 * @return {LabArticleData}
 */
export function getArticleData(containerEl) {
  const articleEl = containerEl.closest('article');
  if (!articleEl) {
    return {};
  }
  const { id } = articleEl.dataset;

  // TODO: We shouldn't use the GA article data for this, since that's crossing module boundaries.
  // Instead the data should be available on the <article/> element itself.
  const dataElSelector = `#gaArticleFields${id}`;

  /** @type {HTMLElement} */
  const dataEl = document.querySelector(dataElSelector);
  if (!dataEl) {
    throw new Error(`Couldn't find article data for ${containerEl} (missing selector '${dataElSelector}')`);
  }

  const articleData = { ...(dataEl.dataset || {}) };

  const verticals = (() => {
    try {
      return JSON.parse(articleData.verticals);
    } catch (e) {
      return [];
    }
  })();

  const title = articleData.title || document.title;
  const url = articleData.url || document.location.href;
  const section = articleData.section;

  return {
    id,
    title,
    section,
    url,
    verticals,
  };
}
